// tslint:disable: deprecation
// tslint:disable: directive-selector
import { Directive, Input, HostListener, ElementRef } from "@angular/core";

@Directive({
    selector: "[OnlyNumber]"
})
@Directive({
    selector: "[OnlyNumberAllowNegative]"
})
@Directive({
    selector: "[OnlyNumberAllowDecimal]"
})
@Directive({
    selector: "[OnlyNumberEnableBlurClean]"
})
export class OnlyNumberDirective {
    constructor(private el: ElementRef) { }

    // https://stackblitz.com/edit/angular-icqojr?file=src%2Fapp%2Fhighlight.directive.ts
    // AllowNegative, AllowDecimal
    // true, true: any float number, -2, -1.1, 0, 1.1, 2
    // false, false: 0 and positive integer, 0, 1, 2
    // false, true: 0 and positive number, 0, 1.1, 2
    // true, false: 0 and integer, -2, -1, 0
    @Input() OnlyNumberAllowNegative = true;
    @Input() OnlyNumberAllowDecimal = true;
    @Input() OnlyNumberEnableBlurClean = true;

    @HostListener("blur", ["$event"]) onBlur(event) {
        const allowNegative = String(this.OnlyNumberEnableBlurClean).toLowerCase() === "true";
        if (allowNegative) {
            let value = this.el.nativeElement.value;
            value = this.cleanInputOnBlur(value);
            this.el.nativeElement.value = value;
        }
      }

    cleanInputOnBlur(value: string) {
        value = this.cleanValueOnInput(value);
        if (value.endsWith(".")) {
            value = value.slice(0, -1);
        }
        if (value === "-0") {
            value = "0";
        }
        if (value === "-") {
            value = "";
        }
        return value;
    }

    @HostListener("keyup", ["$event"]) onKeyUp(event) {
        this.el.nativeElement.value = this.cleanValueOnInput(this.el.nativeElement.value);
    }
    cleanValueOnInput(value: string) {
        const allowNegative = String(this.OnlyNumberAllowNegative).toLowerCase() === "true";
        const allowDecimal = String(this.OnlyNumberAllowDecimal).toLowerCase() === "true";
        value = value.replace(/[^\d.-]/g, "");

        // only first letter is "-", replace it after the first "-"
        if (value.indexOf("-") > -1) {
            if (allowNegative) {
                value = value.slice(0, 1) + value.slice(1).replace(/\-/g, "");
            } else {
                value = value.replace(/\-/g, "");
            }
        }
        if (allowDecimal) {
            // 01, 00 will be 0
            if (value.startsWith("0") && value.slice(1, 2) !== ".") {
                value = "0";
            }
            // -01, -00 will be -0
            if (value.startsWith("-0") && value.slice(2, 3) !== ".") {
                value = "-0";
            }
            // do not allow . to be the first.
            if (value.startsWith(".")) {
                value = value.slice(1);
            }
            if (value.startsWith("-.")) {
                value = "-";
            }
            // only allow one ".", replace it after the first "."
            if ((value.match(/\./g) || []).length > 1) {
                const dotIndex = value.indexOf(".");
                value =
                    value.slice(0, dotIndex + 1) +
                    value.slice(dotIndex + 1).replace(/\./g, "");
            }
        } else {
            if (value.startsWith("0") || value.startsWith("-0")) {
                value = "0";
            } else {
                value = value.replace(/\./g, "");
            }
        }
        return value;
    }
}
